// Simple i18n with 6 languages. Keys map directly to UI text.
export const LANGUAGES = [
  { code: "en", name: "English", native: "English" },
  { code: "hi", name: "Hindi", native: "हिन्दी" },
  { code: "te", name: "Telugu", native: "తెలుగు" },
  { code: "ta", name: "Tamil", native: "தமிழ்" },
  { code: "kn", name: "Kannada", native: "ಕನ್ನಡ" },
  { code: "mr", name: "Marathi", native: "मराठी" },
];

export const STRINGS = {
  en: {
    app_tagline: "Field Force Management, simplified.",
    login: "Login", logout: "Logout", phone: "Phone Number", enter_phone: "Enter your mobile number",
    send_otp: "Send OTP", verify_otp: "Verify OTP", enter_otp: "Enter 6-digit OTP",
    resend_otp_in: "Resend OTP in", resend_otp: "Resend OTP",
    super_admin: "Super Admin", tenant_admin: "Tenant Admin", manager: "Manager",
    employee: "Employee", customer: "Customer/Dealer",
    sms: "SMS", whatsapp: "WhatsApp", language: "Language",
    welcome: "Welcome", dashboard: "Dashboard", tenants: "Tenants", plans: "Plans", settings: "Settings",
    employees: "Employees", dealers: "Dealers", products: "Products", reports: "Reports",
    orders: "Orders", enquiries: "Enquiries", branding: "Branding",
    check_in: "Check In", check_out: "Check Out", my_dealers: "My Dealers", visit_report: "Visit Report",
    collection_entry: "Collection", sales_entry: "Sales", dcr: "Daily Call Report",
    catalogue: "Catalogue", notifications: "Notifications",
    cart: "Cart", account: "My Account", place_order: "Place Order",
    today: "Today", total: "Total", outstanding: "Outstanding", attendance: "Attendance",
    name: "Name", code: "Code", phone_short: "Phone", email: "Email", address: "Address",
    village: "Village", district: "District", state: "State", area: "Area", role: "Role",
    save: "Save", cancel: "Cancel", edit: "Edit", delete: "Delete", add: "Add", create: "Create",
    search: "Search", filter: "Filter", status: "Status", date: "Date", amount: "Amount",
    quantity: "Quantity", price: "Price", remarks: "Remarks",
    no_data: "No data yet", required: "Required",
    demo_logins: "Demo Logins (Tap to use)", tenant_slug: "Tenant",
    landing_title: "FieldCRM", landing_sub: "Multi-tenant field force platform for agriculture, FMCG, pharma & more.",
    enter_tenant: "Enter tenant", tenant_placeholder: "e.g. demo",
    continue: "Continue", back: "Back",
    home: "Home", profile: "Profile",
    new: "New", in_progress: "In Progress", followup: "Follow-up", closed: "Closed",
    submitted: "Submitted", approved: "Approved", rejected: "Rejected", packed: "Packed",
    dispatched: "Dispatched", delivered: "Delivered", cancelled: "Cancelled",
    select: "Select", upload_photo: "Upload Photo", capture_gps: "Capture GPS",
    location: "Location", view_map: "View Map", routes: "Routes",
    sales: "Sales", collections: "Collections", visits: "Visits",
    add_to_cart: "Add to Cart", remove: "Remove", checkout: "Checkout",
    super_admin_login: "Super Admin Login Detected",
  },
  hi: {
    app_tagline: "फील्ड फोर्स प्रबंधन, सरल।",
    login: "लॉगिन", logout: "लॉगआउट", phone: "मोबाइल नंबर", enter_phone: "अपना मोबाइल नंबर दर्ज करें",
    send_otp: "OTP भेजें", verify_otp: "OTP सत्यापित करें", enter_otp: "6 अंकों का OTP दर्ज करें",
    resend_otp_in: "OTP फिर भेजें", resend_otp: "OTP फिर भेजें",
    super_admin: "सुपर एडमिन", tenant_admin: "टेनेंट एडमिन", manager: "मैनेजर",
    employee: "कर्मचारी", customer: "ग्राहक/डीलर",
    sms: "SMS", whatsapp: "व्हाट्सएप", language: "भाषा",
    welcome: "स्वागत है", dashboard: "डैशबोर्ड", tenants: "टेनेंट्स", plans: "योजनाएँ", settings: "सेटिंग्स",
    employees: "कर्मचारी", dealers: "डीलर", products: "उत्पाद", reports: "रिपोर्ट्स",
    orders: "ऑर्डर", enquiries: "पूछताछ", branding: "ब्रांडिंग",
    check_in: "चेक-इन", check_out: "चेक-आउट", my_dealers: "मेरे डीलर", visit_report: "विज़िट रिपोर्ट",
    collection_entry: "वसूली", sales_entry: "बिक्री", dcr: "दैनिक कॉल रिपोर्ट",
    catalogue: "कैटलॉग", notifications: "सूचनाएँ",
    cart: "कार्ट", account: "मेरा खाता", place_order: "ऑर्डर दें",
    today: "आज", total: "कुल", outstanding: "बकाया", attendance: "उपस्थिति",
    name: "नाम", code: "कोड", phone_short: "फोन", email: "ईमेल", address: "पता",
    village: "गाँव", district: "जिला", state: "राज्य", area: "क्षेत्र", role: "भूमिका",
    save: "सहेजें", cancel: "रद्द करें", edit: "संपादित", delete: "हटाएँ", add: "जोड़ें", create: "बनाएँ",
    search: "खोजें", filter: "फ़िल्टर", status: "स्थिति", date: "तारीख़", amount: "राशि",
    quantity: "मात्रा", price: "मूल्य", remarks: "टिप्पणी",
    no_data: "कोई डेटा नहीं", required: "आवश्यक",
    demo_logins: "डेमो लॉगिन (टैप करें)", tenant_slug: "टेनेंट",
    landing_title: "FieldCRM", landing_sub: "कृषि, FMCG, फार्मा और अधिक के लिए मल्टी-टेनेंट फील्ड फोर्स प्लेटफ़ॉर्म।",
    enter_tenant: "टेनेंट दर्ज करें", tenant_placeholder: "जैसे demo",
    continue: "जारी रखें", back: "वापस",
    home: "होम", profile: "प्रोफ़ाइल",
    new: "नया", in_progress: "प्रगति में", followup: "फ़ॉलोअप", closed: "बंद",
    submitted: "जमा किया", approved: "स्वीकृत", rejected: "अस्वीकृत", packed: "पैक",
    dispatched: "भेजा गया", delivered: "वितरित", cancelled: "रद्द",
    select: "चुनें", upload_photo: "फोटो अपलोड", capture_gps: "GPS कैप्चर",
    location: "स्थान", view_map: "नक़्शा देखें", routes: "मार्ग",
    sales: "बिक्री", collections: "वसूली", visits: "विज़िट",
    add_to_cart: "कार्ट में जोड़ें", remove: "हटाएँ", checkout: "चेकआउट",
    super_admin_login: "सुपर एडमिन लॉगिन का पता चला",
  },
  te: {
    app_tagline: "ఫీల్డ్ ఫోర్స్ నిర్వహణ, సరళంగా.",
    login: "లాగిన్", logout: "లాగౌట్", phone: "ఫోన్ నంబర్", enter_phone: "మీ మొబైల్ నంబర్‌ను నమోదు చేయండి",
    send_otp: "OTP పంపండి", verify_otp: "OTP ధృవీకరించండి", enter_otp: "6-అంకెల OTP",
    resend_otp_in: "మళ్ళీ OTP", resend_otp: "మళ్ళీ OTP పంపండి",
    super_admin: "సూపర్ అడ్మిన్", tenant_admin: "టెనెంట్ అడ్మిన్", manager: "మేనేజర్",
    employee: "ఉద్యోగి", customer: "కస్టమర్/డీలర్",
    sms: "SMS", whatsapp: "వాట్సాప్", language: "భాష",
    welcome: "స్వాగతం", dashboard: "డాష్‌బోర్డ్", tenants: "టెనెంట్‌లు", plans: "ప్లాన్‌లు", settings: "సెట్టింగ్‌లు",
    employees: "ఉద్యోగులు", dealers: "డీలర్లు", products: "ఉత్పత్తులు", reports: "నివేదికలు",
    orders: "ఆర్డర్‌లు", enquiries: "విచారణలు", branding: "బ్రాండింగ్",
    check_in: "చెక్-ఇన్", check_out: "చెక్-అవుట్", my_dealers: "నా డీలర్‌లు", visit_report: "విజిట్ నివేదిక",
    collection_entry: "వసూలు", sales_entry: "అమ్మకాలు", dcr: "రోజువారీ నివేదిక",
    catalogue: "ఉత్పత్తులు", notifications: "నోటిఫికేషన్‌లు",
    cart: "కార్ట్", account: "నా ఖాతా", place_order: "ఆర్డర్ చేయండి",
    today: "ఈరోజు", total: "మొత్తం", outstanding: "బకాయి", attendance: "హాజరు",
    name: "పేరు", code: "కోడ్", phone_short: "ఫోన్", email: "ఇమెయిల్", address: "చిరునామా",
    village: "గ్రామం", district: "జిల్లా", state: "రాష్ట్రం", area: "ప్రాంతం", role: "పాత్ర",
    save: "సేవ్", cancel: "రద్దు", edit: "మార్చు", delete: "తొలగించు", add: "జోడించు", create: "సృష్టించు",
    search: "శోధన", filter: "ఫిల్టర్", status: "స్థితి", date: "తేదీ", amount: "మొత్తం",
    quantity: "పరిమాణం", price: "ధర", remarks: "వ్యాఖ్యలు",
    no_data: "డేటా లేదు", required: "అవసరం",
    demo_logins: "డెమో లాగిన్‌లు", tenant_slug: "టెనెంట్",
    landing_title: "FieldCRM", landing_sub: "వ్యవసాయం, FMCG, ఫార్మా కోసం మల్టీ-టెనెంట్ వేదిక.",
    enter_tenant: "టెనెంట్ నమోదు", tenant_placeholder: "ఉదా. demo",
    continue: "కొనసాగించు", back: "వెనుకకు",
    home: "హోమ్", profile: "ప్రొఫైల్",
    new: "కొత్తది", in_progress: "ప్రగతిలో", followup: "ఫాలో-అప్", closed: "ముగిసింది",
    submitted: "సమర్పించబడింది", approved: "ఆమోదించబడింది", rejected: "తిరస్కరించబడింది", packed: "ప్యాక్",
    dispatched: "పంపబడింది", delivered: "డెలివరీ", cancelled: "రద్దయింది",
    select: "ఎంచుకోండి", upload_photo: "ఫోటో అప్‌లోడ్", capture_gps: "GPS క్యాప్చర్",
    location: "స్థానం", view_map: "మ్యాప్ చూడండి", routes: "మార్గాలు",
    sales: "అమ్మకాలు", collections: "వసూళ్లు", visits: "విజిట్‌లు",
    add_to_cart: "కార్ట్‌కి జోడించు", remove: "తొలగించు", checkout: "చెక్‌అవుట్",
    super_admin_login: "సూపర్ అడ్మిన్ లాగిన్",
  },
  ta: { app_tagline: "களப் பணியாளர் மேலாண்மை.", login: "உள்நுழை" },
  kn: { app_tagline: "ಕ್ಷೇತ್ರ ಸಿಬ್ಬಂದಿ ನಿರ್ವಹಣೆ.", login: "ಲಾಗಿನ್" },
  mr: { app_tagline: "फील्ड फोर्स व्यवस्थापन.", login: "लॉगिन" },
};

export function t(lang, key) {
  const dict = STRINGS[lang] || STRINGS.en;
  return dict[key] || STRINGS.en[key] || key;
}
